import { HostListener, Directive } from "@angular/core";
import { Observable } from "rxjs";

@Directive()
export abstract class ComponentCanDeactivate {


  canDeactivate(): Observable<boolean> | Promise<boolean> | boolean
  {
    return true;
  }

  //abstract canDeactivate(): boolean;
  unloadEventCalled: boolean = false;
  @HostListener('window:beforeunload', ['$event'])
  unloadNotification($event: any) {
    console.log("unload:", $event);
    this.unloadEventCalled = true;
    if (!this.canDeactivate()) {
      $event.returnValue = true;
    }
  }
}
